import type { VerifiedMove } from '../../types';

export interface MoveListProps {
  moves: VerifiedMove[];
  currentPly: number; // 0 = position de départ
  onJump: (ply: number) => void;
  highlightPlies?: Set<number>;
}

/** Regroupe les demi-coups par numéro de coup plein pour l'affichage "1. e4 e5". */
function groupByMoveNumber(moves: VerifiedMove[]) {
  const groups: { moveNumber: number; white?: VerifiedMove; black?: VerifiedMove }[] = [];
  for (const m of moves) {
    let group = groups[groups.length - 1];
    if (!group || group.moveNumber !== m.moveNumber) {
      group = { moveNumber: m.moveNumber };
      groups.push(group);
    }
    if (m.color === 'w') group.white = m;
    else group.black = m;
  }
  return groups;
}

export function MoveList({ moves, currentPly, onJump, highlightPlies }: MoveListProps) {
  const groups = groupByMoveNumber(moves);

  return (
    <div className="move-list" role="list" aria-label="Liste des coups">
      <button
        type="button"
        className={`move-chip start-chip ${currentPly === 0 ? 'active' : ''}`}
        onClick={() => onJump(0)}
      >
        Début
      </button>
      {groups.map((g) => (
        <span className="move-row" key={g.moveNumber}>
          <span className="move-number">{g.moveNumber}.</span>
          {g.white && (
            <MoveChip move={g.white} active={currentPly === g.white.ply} flagged={highlightPlies?.has(g.white.ply)} onJump={onJump} />
          )}
          {g.black && (
            <MoveChip move={g.black} active={currentPly === g.black.ply} flagged={highlightPlies?.has(g.black.ply)} onJump={onJump} />
          )}
        </span>
      ))}
    </div>
  );
}

function MoveChip({
  move,
  active,
  flagged,
  onJump,
}: {
  move: VerifiedMove;
  active: boolean;
  flagged?: boolean;
  onJump: (ply: number) => void;
}) {
  return (
    <button
      type="button"
      className={`move-chip ${active ? 'active' : ''} ${flagged ? 'flagged' : ''}`}
      onClick={() => onJump(move.ply)}
      aria-current={active}
    >
      {move.san}
    </button>
  );
}
